import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useGetToken } from "../../lib/hooks"
import { getUser } from "../../lib/fetchApi"
import { notificationActions } from "../../store/notifications"
import { permissionsActions } from "../../store/permissions"
import { setStorageItem } from "../../lib/script"
import { userActions } from "../../store/user"
import LoadingWrapper from "../common/LoadingWrapper"
import Login from "./Login"
import { useNavigate } from "react-router-dom"

export default function LoginWrapper() {
    const [showLoading, setShowLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const localStorageToken = localStorage.getItem('token')
    const storeToken = useGetToken()

    useEffect(() => {
        const message = sessionStorage.getItem('authRedirectMessage')
        if (message) {
            sessionStorage.removeItem('authRedirectMessage')
            dispatch(notificationActions.setError({ errorMessage: message }))
        }
    }, [dispatch])

    useEffect(() => {
        let isMounted = true;
        if (localStorageToken == storeToken) {
            return;
        }

        const tryToGetUser = async (token) => {
            if (!isMounted) return;

            setShowLoading(true)
            const user = await getUser(token)

            if (user && user.errorMessage) {
                dispatch(notificationActions.setError(user)) 
                localStorage.removeItem('token')
                navigate('/')
            } else {
                dispatch(permissionsActions.setEditPermissions(user.permissions))               

                setStorageItem('user', user)
                dispatch(userActions.setToken(localStorageToken))
                dispatch(userActions.setUser(user))

                // const systemAlerts = await getSystemAlerts(token)
                // if (systemAlerts && !systemAlerts.errorMessage) {
                //     dispatch(systemActions.setSystemAlerts(systemAlerts))
                // }              


                navigate(`/dashboard`, {replace: true});
                
            }  
            setShowLoading(false)
        }

        if (localStorageToken && !storeToken) {
            tryToGetUser(localStorageToken)
        }


        return () => {
            isMounted = false;
        };
    }, [localStorageToken, storeToken]) 

    if (showLoading) {
        return <LoadingWrapper />;
    }

    return <Login /> 
}